import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import SessionInfo from '../SessionInfo';
import { VIEW_MODE_SBS } from '../../../../constants/Enums';

const Props = {
    sessions: PropTypes.arrayOf(
        PropTypes.shape(
            {
                sessionId: PropTypes.number.isRequired,
                time: PropTypes.string,
                duration: PropTypes.string,
                name: PropTypes.string.isRequired,
                speakerRole: PropTypes.string.isRequired,
                excerpt: PropTypes.string,
                location: PropTypes.string
            }
        )
    )
};

const SpeakerSessions = ({ sessions, isWidget, agendaUrl, settings, event }) => {
    const isWidgetParam = isWidget ? '?widget=true' : '';
    return (
        <Row className="speaker-sessions margin-bottom-small">
            <div className="speaker-section-notch custom-color color-1-background"/>
            <Col lg={10} lgOffset={1}>
                <h1 className="speaker-sessions-title text-ellipsis bz-bold custom-font  margin-left-small margin-right-small">SESSIONS</h1>
                {
                    sessions.map((
                        {
                            sessionId,
                            name,
                            speakerRole,
                            excerpt,
                            location,
                            ...sessionRest
                        }
                    ) => (
                        <Row key={`session_${sessionId}`}>
                            <Col className="speaker-session margin-left-small margin-right-small padding-top-small padding-bottom-small" lg={12}>
                                <Link to={`${agendaUrl}/session/${sessionId}${isWidgetParam}`}>
                                    <div className="session-info-text">
                                        <SessionInfo
                                            session={{ ...sessionRest }}
                                            settings={settings}
                                            event={event}
                                            shouldRenderStartDate
                                        />
                                    </div>
                                    <div className="speaker-session-title margin-bottom-xs">
                                        {name} {speakerRole &&
                                    <span>- <span className="speaker-session-role">{speakerRole}</span></span>}
                                    </div>

                                </Link>
                                {
                                    excerpt &&
                                        <div className="speaker-session-excerpt margin-bottom-xs"
                                            dangerouslySetInnerHTML={{__html: excerpt}}
                                        >
                                        </div>
                                }
                                {
                                    location &&
                                    <div className="speaker-session-location bz-flex-row">
                                        <i className="speaker-session-location-icon icon-locator2 custom-color color-1"/>
                                        {location}
                                    </div>
                                }
                            </Col>
                        </Row>
                    ))
                }
            </Col>
        </Row>
    );
};

SpeakerSessions.propType = Props;

export default SpeakerSessions;
